// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"486":"cc1adc6a","899":"711b0212","922":"8e86df08"}[chunkId] + ".css";
};